import React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import { useSearchParams } from "routes/hooks";

import history from "data/history";

import { useFeatures } from "components/FeatureFlag";

import { Grid, HubCard, HubName } from "./components";

export function HubSelector({ hubs, onHubSelected }) {
  const [searchParams] = useSearchParams();
  const showHubIdFeatureFlag = useFeatures("hub-selector-show-hubid");
  const location = useLocation();

  if (hubs.length === 1) {
    onHubSelected(
      hubs[0],
      { sharedResourceId: searchParams?.sharedResourceId },
      location.state?.redirectPath || ""
    );
    return null;
  }

  if (hubs.length === 0) {
    return <p style={{ textAlign: "center" }}>No Available Hub exists</p>;
  }

  return (
    <div
      data-test="hub-selector"
      style={{ height: "100vh", overflowY: "auto", paddingBottom: "4em" }}
    >
      <Grid itemsPerRow={3}>
        {hubs.map((h) => {
          return (
            <HubCard
              key={h.id}
              name={
                <HubName
                  name={h.name}
                  hubId={showHubIdFeatureFlag ? h.hubId : undefined}
                />
              }
              type={h.clientPool?.type}
              onClick={() => {
                return onHubSelected(h);
              }}
            />
          );
        })}
      </Grid>
    </div>
  );
}

HubSelector.propTypes = {
  hubs: PropTypes.array,
  onHubSelected: PropTypes.func.isRequired,
};

HubSelector.defaultProps = {
  hubs: [],
};

const mapStateToProps = (state) => {
  return {
    hubs: state.hubly.data.advisor?.hubs || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onHubSelected: (hub, state, redirect = "") => {
      history.push(`/hub/${hub.hubId}${redirect}`, state);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HubSelector);
